import { z } from 'zod';
import { PLANS } from '../constants.js';
import { paginated } from './common.js';
export const billingCheckoutSchema = z.object({
    plan: z.enum(['starter', 'pro', 'enterprise']),
    interval: z.enum(['month', 'year']),
});
export const billingDetailSchema = z.object({
    plan: z.enum(PLANS),
    trialEndsAt: z.string().nullable(),
    aiCreditsBalance: z.number().int(),
    topupCreditsRemaining: z.number().int(),
    planCreditsPerMonth: z.number().int(),
    smsCreditsBalance: z.number().int(),
    smsTopupCreditsRemaining: z.number().int(),
    smsCreditsPerMonth: z.number().int(),
    twilioNumberLimit: z.number().int(),
    seatCount: z.number().int(),
    seatLimit: z.number().int().nullable(),
    subscriptionStatus: z.string().nullable(),
    currentPeriodEnd: z.string().nullable(),
    cancelAtPeriodEnd: z.boolean(),
});
export const creditLedgerEntrySchema = z.object({
    id: z.string().uuid(),
    deltaCredits: z.number().int(),
    reason: z.string(),
    createdAt: z.string(),
});
export const creditLedgerResponseSchema = paginated(creditLedgerEntrySchema);
export const checkoutUrlResponseSchema = z.object({ url: z.string() });
//# sourceMappingURL=billing.js.map